import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

export const ALL_DEPARTMENTS = "all"
export const NO_DEPARTMENT = "none"

const useStyles = makeStyles()(() => ({
    input: {
        minWidth: "12rem",
    },
}))

type SelectDepartmentDropdownProps = Readonly<{
    departments: ReadonlyArray<string>
    department: string
    setDepartment: (department: string) => void
}>

export function SelectDepartmentDropdown({ departments, department, setDepartment }: SelectDepartmentDropdownProps) {
    const { classes } = useStyles()

    const options = [
        {
            value: ALL_DEPARTMENTS,
            label: (
                <LocalizedStrict id="create-or-edit-company-workgroup-members-department-filter-all">
                    <span>All departments</span>
                </LocalizedStrict>
            ),
        },
        ...departments.map((name) => ({ value: name, label: name })),
        {
            value: NO_DEPARTMENT,
            label: (
                <LocalizedStrict id="create-or-edit-company-workgroup-members-department-filter-none">
                    <span>No department</span>
                </LocalizedStrict>
            ),
        },
    ]

    return (
        <FormControl className={classes.input} size="small">
            <LocalizedStrict id="create-or-edit-company-workgroup-members-department-filter-label">
                <InputLabel id="workgroup-members-department-label">Department</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="create-or-edit-company-workgroup-members-department-filter" attrs={{ label: true }}>
                <Select
                    labelId="workgroup-members-department-label"
                    value={department}
                    label="Department"
                    onChange={(event) => setDepartment(event.target.value)}
                >
                    {options.map(({ value, label }) => (
                        <MenuItem key={value} value={value}>
                            {label}
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
